<template>
  <on-click-outside @outside="show = false">
    <div class="dropdown-button-layout" @mouseover="show = true && enabled" @mouseleave="show = false">
      <button @click="show = true" class="button" :class="[enabled ? 'primary' : 'secondary']" :disabled="!enabled">
        <content-spinner v-if="loading" size="20" color="white"/>
        <span v-else class="db tc">{{ title }}</span>
      </button>
      <div v-if="show" class="relative">
        <ul class="dropdown-button-options">
          <li v-for="(action, index) in actions" :key="index" @click="selected(action)"
            class="f6" :class="[action.enabled ? 'dropdown-button-option' : 'dropdown-button-option-disabled']">
            {{ action.title }}
          </li>
        </ul>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import OnClickOutside from './OnClickOutside.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'

export default {
  props: {
    title: { default: 'Применить' },
    loading: { default: false },
    actions: { default: [] }
  },
  components: {
    OnClickOutside,
    ContentSpinner
  },
  computed: {
    enabled () {
      return Array.isArray(this.actions) && this.actions.length > 0
    }
  },
  data () {
    return {
      show: false,
      hovered: false
    }
  },
  methods: {
    selected (action) {
      if (!action.enabled) return
      this.show = false
      this.$emit('selected', action)
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-button-layout {
  display: inline-grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
}
.dropdown-button-options {
  position: absolute;
  top: 0rem;
  right: 0;
  padding: 0;
  -webkit-box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.2);
  z-index: 50;
  background-color: white;
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 14rem;
  min-width: 8rem;
}
.dropdown-button-option {
  margin: 0;
  padding: .75rem 1rem .75rem 1rem;
  color: #334E68;
  border-left: 0;
  border-right: 0;
  border-top: 0px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #eeeeee;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap !important;
  &:hover {
    background-color: #F4F4F4;
  }
  &.is-active,
  &.is-active:hover {
    background-color: #F0F4F8;
    color: #334E68;
  }
}
.dropdown-button-option-disabled {
  @extend .dropdown-button-option;
  color: #99abb8;
  cursor: default;
  &:hover {
    background-color: white;
  }
}
</style>
